import { useEffect, useRef } from "react";

import { useDispatch } from "react-redux";

import { getOrgInfoAction, getOrgLogoAction } from "@/store/ducks/organization";
import { getProfileInfoAction } from "@/store/ducks/profile";
import { setUserInfoAction } from "@/store/ducks/userAccount";


import { API_URL } from "@/constants/envVariables";

import { getSdpTenantName } from "@/helpers/getSdpTenantName";

import { useRedux } from "@/hooks/useRedux";

import { ApiProfileInfo } from "@/types";

import { AppDispatch } from "@/store";

export const KeycloakUserSession = () => {
  const { userAccount, profile, organization } = useRedux("userAccount", "profile", "organization");
  const dispatch: AppDispatch = useDispatch();
  const initRef = useRef(false);

  // On mount, load profile from backend (Istio handles authentication)
  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;

    const loadProfile = async () => {
      try {
        const response = await fetch(`${API_URL}/profile`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "SDP-Tenant-Name": getSdpTenantName(),
          },
        });

        if (response.status === 401) {
          // Not authenticated — reload page so Istio redirects to Keycloak
          window.location.reload();
          return;
        }

        if (!response.ok) {
          // Server error — retry by reloading; Istio may redirect to Keycloak
          window.location.reload();
          return;
        }

        const profileData: ApiProfileInfo = await response.json();

        dispatch(
          setUserInfoAction({
            id: profileData.id,
            email: profileData.email,
            roles: profileData.roles,
          }),
        );
      } catch {
        // Network error — reload page so Istio can handle redirect
        window.location.reload();
      }
    };

    loadProfile();
  }, [dispatch]);

  // Load profile and org info once authenticated
  useEffect(() => {
    if (userAccount.isAuthenticated) {
      if (!profile.data.email) {
        dispatch(getProfileInfoAction());
      }

      if (!organization.data.name) {
        dispatch(getOrgInfoAction());
        dispatch(getOrgLogoAction());
      }
    }
  }, [dispatch, organization.data.name, profile.data.email, userAccount.isAuthenticated]);

  useEffect(() => {
    return () => {
      if (organization.data.logo) {
        URL.revokeObjectURL(organization.data.logo);
      }
    };
  }, [organization.data.logo]);

  return null;
};
